import Vue from "vue";
import Vuex from "vuex";

import global from "./modules/global.js";
import account from "./modules/account.js";
import internalChat from "./modules/internalChat.js";
import clientChat from "./modules/clientChat.js";
import videoCall from "./modules/videoCall.js";
import videoCallRTC from "./modules/videoCallRTC.js";
import webrtc from "./modules/webrtc.js";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    global,
    account,
    clientChat,
    internalChat,
    videoCall,
    videoCallRTC,
    webrtc,
  },
});
